var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 62,
    viewBox: "0 0 42 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0019 0C15.4341 0.00611811 10.096 2.22179 6.15876 6.16096C2.22151 10.1001 0.00662504 15.4411 0 21.0121C0 26.0942 3.58889 34.6574 10.9746 47.1911C11.8911 48.7458 12.7787 50.2118 13.6181 51.5758C16.5524 56.3265 18.8628 59.7402 18.8859 59.7711L20.0527 61.4914C20.1585 61.6484 20.3011 61.7769 20.4681 61.8658C20.6351 61.9547 20.8214 62.0012 21.0106 62.0012C21.1998 62.0012 21.386 61.9547 21.5531 61.8658C21.7201 61.7769 21.8627 61.6484 21.9685 61.4914L23.168 59.7056C23.9054 58.6094 26.5354 54.6543 29.5467 49.6724C31.3084 46.7615 32.841 44.1088 34.2331 41.56L34.4468 41.1632C39.4527 31.9372 42 25.156 42 21.0044C41.9919 15.4352 39.7768 10.0965 35.8405 6.15903C31.9042 2.22153 26.5679 0.00662467 21.0019 0ZM21.0019 33.018C18.7518 33.0176 16.5524 32.3497 14.6817 31.0986C12.811 29.8475 11.3531 28.0695 10.4923 25.9894C9.63151 23.9093 9.40648 21.6205 9.84569 19.4124C10.2849 17.2043 11.3686 15.1761 12.9598 13.5843C14.551 11.9925 16.5781 10.9085 18.785 10.4694C20.9919 10.0303 23.2793 10.2559 25.3581 11.1175C27.4369 11.9792 29.2136 13.4382 30.4636 15.3102C31.7137 17.1822 32.3809 19.383 32.3809 21.6344C32.3778 24.6529 31.1779 27.5469 29.0445 29.6811C26.9112 31.8153 24.0187 33.0154 21.0019 33.018Z",
    fill: "#00B2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.3678c4c1e46a1e9911bfd94870b55fc7.svg";
export { ForwardRef as ReactComponent };